import React from 'react';
import { useTranslation } from 'react-i18next';
import { SyncOutlined, EditOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { PRODUCT } from '../../../constants/define/translation';
import { PAGES } from '../../../constants/urls/page-urls';

interface titleProduct {
  titleProduct: string;
  subTitleProduct: string;
}

interface ProductCatalogHeaderProps {
  onGetEcomProduct?: () => void;
  extraDropdown?: any;
  textProduct?: titleProduct;
}

export const ProductCatalogHeader = (props: ProductCatalogHeaderProps) => {
  const { t } = useTranslation(PRODUCT);
  const history = useHistory();
  const { onGetEcomProduct, extraDropdown, textProduct } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.button.update'),
      bgWhite: 'true',
      onClick: onGetEcomProduct,
      icon: <SyncOutlined />,
    },
  ];

  const handeEdit = () => {
    history.push(PAGES.TEXT);
  };

  return (
    <StyledContainer>
      <div>
        <div style={{ display: 'flex' }}>
          <p className="title">{textProduct?.titleProduct || t('title.productCatalog')}</p>
          <EditOutlined onClick={handeEdit} style={{ marginTop: '10px', marginLeft: '5px', fontSize: '22px' }} />
        </div>

        <p className="sub-title">{textProduct?.subTitleProduct || t('title.subProductCatalog')}</p>
      </div>
      <ContentPageHeader title="" extra={extra} extraDropdown={extraDropdown} sortingEnabled />
    </StyledContainer>
  );
};
const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  .title {
    font-size: 25px;
    font-weight: 600;
    margin-top: 0px;
    margin-left: 25px;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 400;
    margin-top: -10px;
    margin-left: 25px;
  }
`;
